export default __webpack_public_path__ + "static/media/prod8.2639ad65.jpg";